document.addEventListener('DOMContentLoaded', () => {

const carousels = document.querySelectorAll('.ppc-swiper');

if (!carousels.length) return;

carousels.forEach((slider) => {


const section = slider.closest('.ppc-slider-shell');

const nextBtn = section.querySelector('.ppc-next');
const prevBtn = section.querySelector('.ppc-prev');

new Swiper(slider, {

  slidesPerView: 'auto',

  spaceBetween: 16,

  speed: 700,

  grabCursor: true,

  watchOverflow: true,

  observer: true,

  observeParents: true,

  resistanceRatio: 0.85,

  navigation: {
    nextEl: nextBtn,
    prevEl: prevBtn
  },

  breakpoints: {

    0: {
      spaceBetween: 12
    },

    750: {
      spaceBetween: 12
    },

    1200: {
      spaceBetween: 12
    }

  }

});


});

/* ======================================
QUICK VIEW FOUNDATION
(V4 will use this)
====================================== */

document.addEventListener('click', function(e){


const quickBtn = e.target.closest('.ppc-btn');
const mobileBtn = e.target.closest('.ppc-mobile-btn');

if(!quickBtn && !mobileBtn) return;

const trigger = quickBtn || mobileBtn;

const handle = trigger.dataset.product;

console.log('Quick View Product:', handle);


});

/* ======================================
ARROW ACCESSIBILITY
====================================== */

document.querySelectorAll('.ppc-arrow').forEach((arrow)=>{


arrow.addEventListener('keydown',(e)=>{

  if(e.key === 'Enter'){
    arrow.click();
  }

});


});

/* ======================================
TOUCH ENHANCEMENT
====================================== */

let startX = 0;

document.querySelectorAll('.ppc-swiper').forEach((slider)=>{


slider.addEventListener('touchstart',(e)=>{

  startX = e.touches[0].clientX;

});

slider.addEventListener('touchend',(e)=>{

  const endX = e.changedTouches[0].clientX;

  const distance = startX - endX;

  if(Math.abs(distance) < 30){
    return;
  }

});


});

/* ======================================
CARD HOVER OPTIMIZATION
====================================== */

document.querySelectorAll('.ppc-card').forEach((card)=>{


card.addEventListener('mouseenter',()=>{

  card.classList.add('is-hovered');

});

card.addEventListener('mouseleave',()=>{

  card.classList.remove('is-hovered');

});


});

});
